export const isTargetObject = <T>(obj: unknown, keys: (keyof T)[]): obj is T => {
  if (!obj || !Array.isArray(keys) || typeof obj !== "object") {
    return false;
  }
  const implementKeys = keys.reduce((impl, key) => impl && key in obj, true);
  return implementKeys;
};

export const isPartialTargetObject = <T>(obj: unknown, keys: (keyof T)[]): obj is T => {
  if (!obj || !Array.isArray(keys) || typeof obj !== "object") {
    return false;
  }
  const implementKeys = keys.find((key) => key in obj) ? true : false;
  return implementKeys;
};
